import React, { useEffect, useRef, useState } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Close, Closecircle, closeCircle, UploadImg } from "../../Svg";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import VariantsCard from "./VariantsCard";
import PricingCard from "./PricingCard";
import RichTextEditor from "./RichTextEditor";
import { addProductThunk, updateProductThunk } from "../../redux/productSlice";
import MediaCard from "./ViewMediaCard";
import ViewPricingCard from "./ViewPricingCard";
import ViewVariantsCard from "./ViewVariantsCard";


const status = ['OUT OF STOCK', 'PUBLISHED', 'DRAFT']
const ViewProduct = ({ productDetails, from, id, loadings }) => {
    const thumbnailImageref = useRef();
    const [loading, setLoading] = useState(false);

    const { exportedData } = useSelector((state) => state.manufacturer);

    const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
    const categories = categoryHeirarchy?.categories || [];
    const subcategory = categoryHeirarchy?.subcategories || [];
    const level3 = categoryHeirarchy?.level3categories || []
    const manufacturer = exportedData?.data || []
    const [filteredSubcategory, setFiilteredSubcategory] = useState([]);
    const [filteredLevel3, setFilteredLevel3] = useState([])
    const { productsdrop } = useSelector((state) => state.products);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const getInitialCategories = () => {
        if (!productDetails?.categories || productDetails.categories.length === 0) {
            return ["", "", ""];
        }
        
        let catLvl1 = productDetails.categories.find(c => {
            const id = c?._id || c;
            return categories.some(x => x._id?.toString() === id?.toString());
        });
        
        let catLvl2 = productDetails.categories.find(c => {
            const id = c?._id || c;
            return subcategory.some(x => x._id?.toString() === id?.toString());
        });
        
        let catLvl3 = productDetails.categories.find(c => {
            const id = c?._id || c;
            return level3.some(x => x._id?.toString() === id?.toString());
        });

        // Get initial IDs from productDetails
        let lvl3Id = catLvl3?._id || (typeof catLvl3 === 'string' ? catLvl3 : "");
        let lvl2Id = catLvl2?._id || (typeof catLvl2 === 'string' ? catLvl2 : "");
        let lvl1Id = catLvl1?._id || (typeof catLvl1 === 'string' ? catLvl1 : "");

        // 1. Trace UP if Level 3 is present
        if (lvl3Id) {
            if (!lvl2Id) {
                const selectedLvl3 = level3.find(x => x._id?.toString() === lvl3Id.toString());
                if (selectedLvl3) {
                    const parentSubId = Array.isArray(selectedLvl3.parentId)
                        ? selectedLvl3.parentId[0]
                        : selectedLvl3.parentId;
                    if (parentSubId) lvl2Id = parentSubId.toString();
                }
            }
        }

        // 2. Trace UP if Sub-Category is present
        if (lvl2Id) {
            if (!lvl1Id) {
                const selectedSub = subcategory.find(x => x._id?.toString() === lvl2Id.toString());
                if (selectedSub) {
                    const parentCatId = Array.isArray(selectedSub.parentId)
                        ? selectedSub.parentId[0]
                        : selectedSub.parentId;
                    if (parentCatId) lvl1Id = parentCatId.toString();
                }
            }
        }

        // 3. Trace DOWN if Category is present but Sub-Category is missing
        if (lvl1Id && !lvl2Id) {
            const defaultSub = subcategory.find(x => {
                const p = x.parentId;
                return Array.isArray(p)
                    ? p.some(val => val?.toString() === lvl1Id.toString())
                    : p?.toString() === lvl1Id.toString();
            });
            if (defaultSub) lvl2Id = defaultSub._id?.toString();
        }

        // 4. Trace DOWN if Sub-Category is present but Level 3 is missing
        if (lvl2Id && !lvl3Id) {
            const defaultLvl3 = level3.find(x => {
                const p = x.parentId;
                return Array.isArray(p)
                    ? p.some(val => val?.toString() === lvl2Id.toString())
                    : p?.toString() === lvl2Id.toString();
            });
            if (defaultLvl3) lvl3Id = defaultLvl3._id?.toString();
        }

        return [
            lvl1Id,
            lvl2Id,
            lvl3Id
        ];
    };

    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm,
    } = useFormik({
        initialValues: {
            productOverview: {
                productNumber: productDetails?.productOverview?.productNumber || [""],
                description: productDetails?.productOverview?.description || [""],
                manufacturer: productDetails?.productOverview?.manufacturer?.map(i => i?._id || i) || [""],
                tags: productDetails?.productOverview?.tags || "",
                manufactureLeadTime: productDetails?.productOverview?.manufactureLeadTime || ""
            },
            attributes: productDetails?.attributes || {},
            environmental: productDetails?.environmental || {},
            categories: getInitialCategories(),
            alternateProducts: productDetails?.alternateProducts || [],
            quantityTable: productDetails?.quantityTable || [
                {
                    breakQty: "",
                    productNumber: "",
                    fee: "",
                    isDiscount: false,
                    minMultiplier: "",
                    packaging: "",
                    unitPrice: "",
                },
            ],
            inventory: {
                sku: productDetails?.inventory?.sku || "",
                qtyAvailable: productDetails?.inventory?.qtyAvailable || null,
                factoryStock: productDetails?.inventory?.factoryStock || null,
                minimumMultiplier: productDetails?.inventory?.minimumMultiplier || null,
                canShipImmediately: productDetails?.inventory?.canShipImmediately || null
            },
            assets: {
                image: productDetails?.assets?.image || [],
                video: productDetails?.assets?.video || [],
                featuredImage: productDetails?.assets?.featuredImage || []
            },
            status: productDetails?.status || "",
            activestatus: "ACTIVE"
        },
        enableReinitialize: true,
    });

    useEffect(() => {
        if (values?.categories?.[0]) {
            if (subcategory?.length > 0) {
                const filteredSub = subcategory?.filter((i) => {
                    const parent = i?.parentId;
                    if (Array.isArray(parent)) {
                        return parent.some(p => p?.toString() === values?.categories[0]?.toString());
                    }
                    return parent?.toString() === values?.categories[0]?.toString();
                });
                setFiilteredSubcategory(filteredSub?.length > 0 ? filteredSub : subcategory);
            } else {
                setFiilteredSubcategory(subcategory);
            }
        } else {
            setFiilteredSubcategory(subcategory);
        }

        if (values?.categories?.[1]) {
            if (level3?.length > 0) {
                const filteredLvl3 = level3?.filter((i) => {
                    const parent = i?.parentId;
                    if (Array.isArray(parent)) {
                        return parent.some(p => p?.toString() === values?.categories[1]?.toString());
                    }
                    return parent?.toString() === values?.categories[1]?.toString();
                });
                setFilteredLevel3(filteredLvl3?.length > 0 ? filteredLvl3 : level3);
            } else {
                setFilteredLevel3(level3);
            }
        } else {
            setFilteredLevel3(level3);
        }
    }, [values.categories, subcategory, level3]);

    if (loadings) {
        return (
            <div>
                Loading...
            </div>
        )
    }

    return (
        <>
            <form className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>General Information</h2>
                        <label className={styles.addCatLabel}>
                            Product Name
                            <input
                                type="text"

                                className={styles.addCatInput}
                                value={values.productOverview.productNumber[0]}

                            />


                        </label>
                        <label
                            className={styles.addCatLabel}
                            style={{ paddingBottom: "8px" }}
                        >
                            Description
                        </label>

                        <RichTextEditor
                            values={values}
                            setFieldValue={setFieldValue}
                        />


                        <label className={styles.addCatLabel}>
                            Tags
                            <input
                                type="text"

                                placeholder="Enter"
                                className={styles.addCatInput}
                                value={values.productOverview?.tags}

                            />
                        </label>
                    </div>

                    <MediaCard

                        values={values}

                    />

                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Inventory</h2>
                        <div style={{ display: "flex", gap: "14px" }}>

                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                SKU
                                <input
                                    type="text"

                                    className={styles.addCatInput}
                                    value={values.inventory.sku}

                                />

                            </label>
                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                Stock
                                <input
                                    type="text"

                                    className={styles.addCatInput}
                                    value={values.inventory.qtyAvailable}

                                />

                            </label>
                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                factoryStock
                                <input
                                    type="text"

                                    className={styles.addCatInput}
                                    value={values.inventory.factoryStock}

                                />
                            </label>
                        </div>
                        <div style={{ display: "flex", gap: "14px" }}>


                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                minimumMultiplier
                                <input
                                    type="text"

                                    className={styles.addCatInput}
                                    value={values.inventory.minimumMultiplier}

                                />

                            </label>
                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                can ShipImmediately
                                <select
                                    className={styles.addCatSelect}
                                    disabled
                                    value={values.inventory.canShipImmediately}
                                >
                                    <option value="">Select...</option>
                                    <option value={true}>YES</option>
                                    <option value={false}>NO</option>

                                </select>
                            </label>
                        </div>
                    </div>

                    <ViewPricingCard

                        values={values}

                    />

                    <ViewVariantsCard
                        values={values}

                    />




                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Category</h2>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Product Category
                            <select
                                className={styles.addCatSelect}
                                disabled
                                value={values.categories[0]}
                            >
                                <option value="">Select...</option>
                                {
                                    categories?.map((cat, index) => (
                                        <option key={index} value={cat?._id}>{cat?.name}</option>
                                    ))
                                }

                            </select>

                        </label>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Product Sub-Category
                            <select
                                className={styles.addCatSelect}
                                value={values.categories[1]}
                                disabled
                            >
                                <option value="">Select...</option>
                                {
                                    filteredSubcategory?.map((sub, index) => (
                                        <option key={index} value={sub?._id}>{sub?.name}</option>
                                    ))
                                }

                            </select>

                        </label>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Level 3
                            <select
                                className={styles.addCatSelect}
                                disabled
                                value={values.categories[2]}
                            >
                                <option value="">Select...</option>
                                {
                                    filteredLevel3?.map((sub, index) => (
                                        <option key={index} value={sub?._id}>{sub?.name}</option>
                                    ))
                                }
                            </select>

                        </label>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Manufacturer
                            <select
                                className={styles.addCatSelect}
                                disabled
                                value={values.productOverview.manufacturer[0]}
                            >
                                <option value="">Select...</option>
                                {
                                    manufacturer?.map((manufacturer, index) => (
                                        <option key={index} value={manufacturer?._id}>{manufacturer?.name}</option>
                                    ))
                                }
                            </select>

                        </label>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Featured image</h2>
                        <p
                            style={{
                                fontSize: "14px",
                                color: "#777980",
                                padding: "20px 0px 6px 0px",
                            }}
                        >
                            Photo
                        </p>

                        {values.assets.featuredImage[0] && (
                            <div
                                className={styles.uploadBox}
                                style={{ display: "flex", justifyContent: "center" }}
                            >
                                <img
                                    src={values.assets.featuredImage[0]}
                                    alt=""
                                    className={styles.previewImage}
                                />

                            </div>
                        )}

                    </div>

                    <div className={styles.card} style={{ marginTop: "20px" }}>
                        <h2 className={styles.addCatH2}>Alternate/exact match</h2>
                        <div style={{ paddingBottom: '10px', display: "block", marginTop: 10 }} className={styles.addCatLabel}>
                            Select
                            <div style={{ position: 'relative' }}>

                                <div
                                    className={styles.addCatSelect}
                                >
                                    Select

                                </div>



                            </div>
                            {values?.alternateProducts?.map((i) => {
                                const manufacturer = productsdrop?.find((item) => item._id === i);
                                return (
                                    <div className={styles.dropdownresult}>
                                        {manufacturer?.productNumber}
                                    </div>
                                )
                            })

                            }

                        </div>
                    </div>

                    <div className={styles.card} style={{ marginTop: "20px" }}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Product Status*
                            <select
                                className={styles.addCatSelect}

                                value={values.status}
                                disabled
                            >
                                <option value="">Select...</option>
                                {
                                    status?.map((i) => (
                                        <option value={i}>{i}</option>
                                    ))
                                }
                            </select>

                        </label>
                    </div>
                </div>
            </form>
        </>
    );
};

export default ViewProduct;
